function GetServerAddress() {
  return window.location.href.includes("localhost")
    ? process.env.REACT_APP_SERVER_LOCAL
    : process.env.REACT_APP_SERVER_ONLINE;
}

export default GetServerAddress;
